/*
 * Layout for the landlord profile section
 */

define(["marionette", "./template/landlordProfileTemplate.html"], function (
  Marionette,
  LandlordProfileTemplate,
) {
  var LandlordProfileView = {
    landlordProfileLayout: Marionette.Layout.extend({
      template: LandlordProfileTemplate,
      tagName: "div",
      className: "row-fluid max-height",
      regions: {
        sideMenu: "#landlordMenu",
        landlordProfile: "#landlordProfile",
      },
    }),
  };

  return LandlordProfileView;
});
